import { getMyNotification } from "@/services";
import { GetNotificationsParams, NOTIFICATION_QUERY_KEYS } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

export const useGetMyNotificationByPages = (
  params: Omit<GetNotificationsParams, "page">
) => {
  const [page, setPage] = useState(1);

  const { data, isLoading, error } = useQuery({
    queryKey: [
      NOTIFICATION_QUERY_KEYS.GET_MY_NOTIFICATION_BY_PAGES,
      page,
      params,
    ],
    queryFn: () => getMyNotification({ ...params, page }),
    retry: 1, // retry once if failed
  });

  if (error) throw error;

  return {
    myNotifications: data?.data || [],
    pagination: data?.pagination,
    isLoading,
    error,
    setPage,
  };
};
